export default __webpack_public_path__ + "static/media/search.b7b0d523.png";